import React, { useEffect, useState } from 'react'
import '../../../Assets/Css/MarkAttendance.scss'
import Select from "react-select";
import { customStyle } from '../../../Components/Style';
import ReactDatePicker from 'react-datepicker';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "../../../Assets/Css/TimeSheet.scss"
import { connect } from 'react-redux';
import { getprojects } from '../../../Services/Project/action';
import { getTasks } from '../../../Services/Task/action';
import UserAvatar from 'react-user-avatar';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import { addTimesheet, getTimesheets, updateTimesheet } from '../../../Services/TimeSheet/action';
import { getUsers } from '../../../Services/Users/action';
import { toast } from 'react-toastify';

const hours = Array.from({ length: 12 }, (_, i) => ({ value: (i + 1).toString().padStart(2, '0'), label: (i + 1).toString().padStart(2, '0') }));
const minutes = Array.from({ length: 60 }, (_, i) => ({ value: i.toString().padStart(2, '0'), label: i.toString().padStart(2, '0') }));
const amPm = [
    { value: 'AM', label: 'AM' },
    { value: 'PM', label: 'PM' }
];

function EmpTimeSheetAddUpdate(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location?.state?.data?.allData;
    useEffect(() => {
        props?.getprojects();
        props?.getTasks();
        props?.getUsers({ module: 'users-names' });
    }, [])
    const { employeeId } = useParams();

    const Project = props?.project?.filter(project => project?.projectUserMap?.find(item => item?.user_id == employeeId) && project?.manual_timelogs == true)?.map((item) => {
        return {
            value: item?.id,
            label: item?.name
        }
    })

    const Task = location.pathname == "/employees/view/task/timesheet/add" ?
        props?.task?.filter(task => task?.taskUserMap?.find(item => item?.user_id == employeeId) && data?.task_id == task?.id)?.map((item) => {
            return {
                value: item?.id,
                label: item?.title
            }
        })
        : props?.task?.filter(task => task?.taskUserMap?.find(item => item?.user_id == employeeId))?.map((item) => {
            return {
                value: item?.id,
                label: item?.title
            }
        })

    const [Fields, setFields] = useState({
        Project: Project?.find(item => item?.value == data?.project?.id) || null,
        Task: Task?.find(item => item?.value == data?.task?.id) || null,
        StartDate: data?.start_date ? new Date(data?.start_date) : null,
        EndDate: data?.end_date ? new Date(data?.end_date) : null,
        ticketsubject: data?.memo || ""
    });

    const convertTo12Hour = (timeString) => {
        if (!timeString) return { hour: null, minute: null, amPm: null };
        const time = moment(timeString, 'HH:mm:ss');
        return {
            hour: hours?.find(item => item.value === time.format('hh')),
            minute: minutes?.find(item => item.value === time.format('mm')),
            amPm: amPm?.find(item => item.value === time.format('A')),
        };
    };


    const [clockIn, setclockIn] = useState(
        convertTo12Hour(data?.start_time)
    );

    const [clockOut, setclockOut] = useState(
        convertTo12Hour(data?.end_time)
    );

    const handleSave = async () => {
        try {
            const formatTo24Hour = (hour, minute, amPm, seconds = "00") => {
                let h = parseInt(hour);
                if (amPm === 'PM' && h !== 12) h += 12;
                if (amPm === 'AM' && h === 12) h = 0;
                return `${String(h).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${seconds}`;
            };

            const getOriginalSeconds = (dateTimeStr) => {
                if (!dateTimeStr) return "00";
                const parts = dateTimeStr.split(" ");
                if (parts.length < 2) return "00";
                const timePart = parts[1];
                const seconds = timePart.split(":")[2];
                return seconds || "00";
            };

            const originalStartSeconds = getOriginalSeconds(data?.start_date);
            const originalEndSeconds = getOriginalSeconds(data?.end_date);
            let startDateTimeStr = null;
            if (Fields?.StartDate && clockIn?.hour?.value && clockIn?.minute?.value && clockIn?.amPm?.value) {
                startDateTimeStr = `${moment(Fields.StartDate).format('YYYY-MM-DD')} ${formatTo24Hour(clockIn?.hour?.value, clockIn?.minute?.value, clockIn?.amPm?.value, originalStartSeconds)}`;
            }

            let endDateTimeStr = null;
            if (Fields?.EndDate && clockOut?.hour?.value && clockOut?.minute?.value && clockOut?.amPm?.value) {
                endDateTimeStr = `${moment(Fields?.EndDate).format('YYYY-MM-DD')} ${formatTo24Hour(clockOut?.hour?.value, clockOut?.minute?.value, clockOut?.amPm?.value, originalEndSeconds)}`;
            }

            if (!Fields?.Task?.value || !Fields?.StartDate || !startDateTimeStr || !Fields?.EndDate || !endDateTimeStr) {
                toast.error("Please fill all the required fields");
                return;
            }
            const body = {
                project_id: Fields?.Project?.value,
                task_id: Fields?.Task?.value,
                start_date: startDateTimeStr,
                end_date: endDateTimeStr,
                start_time: startDateTimeStr.split(" ")[1],
                end_time: endDateTimeStr.split(" ")[1],
                memo: Fields?.ticketsubject,
                employee_id: props?.users?.find(item => item?.id == employeeId)?.id
            }

            if (data?.id) {
                await props?.updateTimesheet(data?.id, body)
            }
            else {
                await props?.addTimesheet(body);
            }
            navigate(-1);
        } catch (error) {
            console.error("Error adding timesheet data :", error);
        }
    }

    const calculateTotalHours = () => {
        if (
            !clockIn.hour || !clockIn.minute || !clockIn.amPm ||
            !clockOut.hour || !clockOut.minute || !clockOut.amPm ||
            !Fields?.StartDate || !Fields?.EndDate) {
            return '0hrs';
        }

        const formattedStartDate = moment(Fields.StartDate).format('YYYY-MM-DD');
        const formattedEndDate = moment(Fields.EndDate).format('YYYY-MM-DD');

        const startDateTimeStr = `${formattedStartDate} ${clockIn.hour.value}:${clockIn.minute.value} ${clockIn.amPm.value}`;
        const endDateTimeStr = `${formattedEndDate} ${clockOut.hour.value}:${clockOut.minute.value} ${clockOut.amPm.value}`;

        const start = moment(startDateTimeStr, 'YYYY-MM-DD hh:mm A');
        const end = moment(endDateTimeStr, 'YYYY-MM-DD hh:mm A');

        if (!start.isValid() || !end.isValid()) return '';

        if (end.isBefore(start)) {
            return 'End time cannot be before start time';
        }

        const duration = moment.duration(end.diff(start));
        const hours = Math.floor(duration.asHours());
        const minutes = duration.minutes();

        return `${hours}Hrs ${minutes.toString().padStart(2, '0')}Mins`;
    };



    return (
        <div className='TaskEmployee-main mb-5'>
            <div className="page-title">
                <h4>{location.pathname?.includes("add") ? "Add" : "Update"} Log Details</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel</button>

                    <button
                        type="submit"
                        className="export-btn"
                        onClick={handleSave}
                    >
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            "Save"
                        )}
                    </button>
                </div>
            </div>

            <div className='row parent-filter m-0 p-4 h-auto'>
                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className='input-group'>
                        <label className='label'>Project</label>
                        <Select
                            value={Fields.Project}
                            onChange={(data) =>
                                setFields({
                                    ...Fields,
                                    Project: data,
                                }
                                )
                            }
                            options={Project}
                            placeholder={"--"}
                            styles={customStyle}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-12">
                    <div className='input-group'>
                        <label className='label'>Task <span style={{ color: 'red' }}>*</span></label>
                        <Select
                            value={Fields.Task}
                            onChange={(data) =>
                                setFields({
                                    ...Fields,
                                    Task: data,
                                }
                                )
                            }
                            options={Task}
                            placeholder={"Task"}
                            styles={customStyle}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: "#5757fe",
                                    primary: "#5757fe",
                                },
                            })}
                        />
                    </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 TimeSheet-user-info mt-5">
                    {props?.users?.filter(item => item?.id == employeeId)?.map((item) => (
                        <div key={item?.id} style={{ display: 'flex', gap: '10px' }}>
                            {item?.profile_pic ? (
                                <img src={`data:image/jpeg;base64,${btoa(
                                    new Uint8Array(
                                        item?.profile_pic?.data
                                    ).reduce(
                                        (data, byte) =>
                                            data + String.fromCharCode(byte),
                                        ""
                                    )
                                )}`} alt="user" />
                            ) : (
                                <UserAvatar name={item?.name} size={40} style={{ textTransform: 'uppercase', color: 'white' }} color="#5757fe" />
                            )}
                            <div className='TimeSheet-user-info-Details'>
                                <span>{item?.name}</span>
                                <span className="role">{item?.designation?.name}</span>
                            </div>
                        </div>
                    ))}
                </div>


                <div className='col-lg-3 col-md-3 col-sm-6'>
                    <div className='input-group'>
                        <lable className='label'>Start Date <span style={{ color: 'red' }}>*</span></lable>
                        <ReactDatePicker
                            selected={Fields.StartDate}
                            dateFormat="dd-MM-yyyy"
                            placeholderText='Start Date'
                            onChange={(date) => {
                                setFields({
                                    ...Fields,
                                    StartDate: date,
                                });
                            }}
                            className='date-picker'
                        />
                    </div>
                </div>

                <div className='col-lg-3 col-md-3 col-sm-6'>
                    <div className='input-group'>
                        <lable className='label'>End Date <span style={{ color: 'red' }}>*</span></lable>
                        <ReactDatePicker
                            selected={Fields.EndDate}
                            dateFormat="dd-MM-yyyy"
                            placeholderText='End Date'
                            onChange={(date) => {
                                setFields({
                                    ...Fields,
                                    EndDate: date,
                                });
                            }}
                            className='date-picker'
                        />
                    </div>
                </div>

                <div className="ccol-lg-3 col-md-3 col-sm-6">
                    <div className='input-group'>
                        <lable className='label'>Start Time <span style={{ color: 'red' }}>*</span></lable>
                        <div className="dropdown-grp">
                            <Select
                                value={clockIn.hour}
                                onChange={(data) => setclockIn({ ...clockIn, hour: data })}
                                options={hours}
                                placeholder="Hour"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                            <Select
                                value={clockIn.minute}
                                onChange={(data) => setclockIn({ ...clockIn, minute: data })}
                                options={minutes}
                                placeholder="Minute"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                            <Select
                                value={clockIn.amPm}
                                onChange={(data) => setclockIn({ ...clockIn, amPm: data })}
                                options={amPm}
                                placeholder="AM/PM"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-3 col-md-3 col-sm-6">
                    <div className="input-group">
                        <label className="label">End Time <span style={{ color: 'red' }}>*</span></label>
                        <div className="dropdown-grp">
                            <Select
                                value={clockOut.hour}
                                onChange={(data) => setclockOut({ ...clockOut, hour: data })}
                                options={hours}
                                placeholder="Hour"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                            <Select
                                value={clockOut.minute}
                                onChange={(data) => setclockOut({ ...clockOut, minute: data })}
                                options={minutes}
                                placeholder="Minute"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                            <Select
                                value={clockOut.amPm}
                                onChange={(data) => setclockOut({ ...clockOut, amPm: data })}
                                options={amPm}
                                placeholder="AM/PM"
                                styles={customStyle}
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary25: "#5757fe",
                                        primary: "#5757fe",
                                    },
                                })}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 description ">
                    <div className='input-group'>
                        <label className='label'>Memo</label>
                        <input
                            value={Fields.ticketsubject}
                            placeholder='eg: working on new log'
                            onChange={(e) =>
                                setFields({
                                    ...Fields,
                                    ticketsubject: e.target.value,
                                }
                                )
                            }
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 description ">
                    <div className='input-group'>
                        <label className='label'>Total</label>
                        <label className='labelTimesheet'>{calculateTotalHours()}</label>
                    </div>
                </div>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        loading: state.timesheetReducer.loading,
        timesheet: state.timesheetReducer.timesheet,
        user: state.authenticationReducer.user,
        task: state.taskReducer.task,
        project: state.projectReducer.project,
        users: state.userReducer.users
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getTimesheets: () => {
            dispatch(getTimesheets());
        },
        addTimesheet: (data) => {
            dispatch(addTimesheet(data));
        },
        updateTimesheet: (id, data) => {
            dispatch(updateTimesheet(id, data));
        },
        getprojects: () => {
            dispatch(getprojects());
        },
        getTasks: () => {
            dispatch(getTasks());
        },
        getUsers: () => {
            dispatch(getUsers());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmpTimeSheetAddUpdate)